import { lineTypes } from '../Constants';

export const FUNNEL_CHART_COLORS = [
  '#7cb5ec',
  '#90cd6d',
  '#d35f55',
  '#2fc0c0',
  '#8085e9',
  '#c36b70',
  '#ffcd56',
  '#ff9f3f',
  '#ff6383',
  '#1abc9c',
  '#f54a00',
  '#5E2129',
  '#6C4675',
  '#EA899A',
  '#4f751A',
  '#f1900A',
  '#ff6383'
];

export const PIE_CHART_COLORS = [
  '#35a2eb',
  '#4bc0c0',
  '#f3c352ff',
  '#ff9f3f',
  '#ff6383'
];
export const TRENDS_SKETCH_BLUE_COLORS = [
  { background: '#d6e6f5', border: '#eaf3fa' },
  { background: '#deebf7', border: '#eaf3fa' },
  { background: '#c6dbef', border: '#ebf2f9' },
  { background: '#9ecae1', border: '#d8eaf3' },
  { background: '#6baed6', border: '#afd4e9' },
  { background: '#4292c6', border: '#b0d2e8' },
  { background: '#2171b5', border: '#93c2eb' },
  { background: '#08519c', border: '#55a6f6' },
  { background: '#08306b', border: '#0e54be' }
];

export const TRENDS_SKETCH_RED_COLORS = [
  { background: '#ffeee6', border: '#ffeee6' },
  { background: '#fee0d2', border: '#feeee6' },
  { background: '#fcbba1', border: '#fddbce' },
  { background: '#fc9272', border: '#fed8cd' },
  { background: '#fb6a4a', border: '#fdc1b4' },
  { background: '#ef3b2c', border: '#f69288' },
  { background: '#cb181d', border: '#ec5f64' },
  { background: '#a50f15', border: '#f27377' },
  { background: '#67000d', border: '#e6001f' }
];

export const RECT_TYPE_COLORS = {
  0: { background: 'rgba(0, 43, 112, 0.3)', border: 'rgba(0, 43, 112, 0.8)' },
  1: {
    background: 'rgba(239, 101, 21, 0.3)',
    border: 'rgba(239, 101, 21, 0.8)'
  },
  2: { background: 'rgba(31, 204, 8, 0.3)', border: 'rgba(31, 204, 8, 0.8)' },
  3: { background: 'rgba(191, 24, 24, 0.3)', border: 'rgba(191, 24, 24, 0.8)' },
  5: {
    background: 'rgba(130, 132, 128, 0.3)',
    border: 'rgba(130, 132, 128, 0.8)'
  },
  6: {
    background: 'rgba(255, 66, 242, 0.3)',
    border: 'rgba(255, 66, 242, 0.8)'
  },
  7: { background: 'rgba(5, 190, 196, 0.3)', border: 'rgba(5, 190, 196, 0.8)' },
  8: {
    background: 'rgba(240, 152, 20, 0.18)',
    border: 'rgba(240, 152, 20, 0.8)'
  },
  9: {
    background: 'rgba(255, 227, 52, 0.3)',
    border: 'rgba(255, 212, 19, 0.5)'
  },
  10: {
    background: 'rgba(232, 122, 155, 0.3)',
    border: 'rgba(232, 122, 155, 0.8)'
  },
  11: {
    background: 'rgba(100, 150, 222, 0.3)',
    border: 'rgba(100, 150, 222, 0.5)'
  },
  12: {
    background: 'rgba(100, 5, 222, 0.3)',
    border: 'rgba(100, 5, 222, 0.5)'
  },
  13: {
    background: 'rgba(30, 213, 120, 0.3)',
    border: 'rgba(30, 213, 120, 0.5)'
  },
  14: {
    background: 'rgba(123, 20, 55, 0.3)',
    border: 'rgba(123, 20, 55, 0.5)'
  }
};
export const RECT_TYPE_COLORS_HOVER = {
  0: { background: 'rgba(0, 43, 112, 0.7)' },
  1: { background: 'rgba(239, 101, 21, 0.7)' },
  2: { background: 'rgba(31, 204, 8, 0.7)' },
  3: { background: 'rgba(191, 24, 24, 0.7)' },
  5: { background: 'rgba(130, 132, 128, 0.7)' },
  6: { background: 'rgba(255, 66, 242, 0.7)' },
  7: { background: 'rgba(5, 190, 196, 0.7)' },
  8: { background: 'rgba(240, 152, 20, 0.7)' },
  10: { background: 'rgba(232, 122, 155, 0.7)' },
  11: { background: 'rgba(100, 150, 222, 0.7)' },
  12: { background: 'rgba(100, 5, 222, 0.7)' },
  13: { background: 'rgba(30, 213, 120, 0.7)' },
  14: { background: 'rgba(123, 20, 55, 0.7)' }
};

export const LINE_TYPE__COLOR = {
  0: {
    undefined: '#ff7700'
    // 1: "#003cff",
    // "-1": "#ff7700"
  },
  1: {
    undefined: '#1abc9c'
  },
  2: {
    undefined: '#f54a00'
  },
  [lineTypes.FloorStaircase]: {
    undefined: '#5E2129'
  },
  [lineTypes.FloorElevator]: {
    undefined: '#6C4675'
  },
  [lineTypes.InFloorOrientation]: {
    undefined: '#EA899A'
  },
  [lineTypes.PassingShopInShop]: {
    undefined: '#5f751A'
  },
  [lineTypes.ShopInShopEntrance]: {
    undefined: '#f1900A'
  },
  undefined: {
    1: '#00ff00',
    '-1': '#ff0000'
  }
};

export const TAPE_COLORS = [
  { width: '450px' },
  { width: '420px' },
  { width: '400px' },
  { width: '390px' },
  { width: '370px' },
  { width: '350px' },
  { width: '330px' },
  { width: '300px' },
  { width: '280px' }
];
